import { render, staticRenderFns } from "./KraalBoard.vue?vue&type=template&id=f412805c&scoped=true"
import script from "./KraalBoard.vue?vue&type=script&lang=ts"
export * from "./KraalBoard.vue?vue&type=script&lang=ts"
import style0 from "./KraalBoard.vue?vue&type=style&index=0&id=f412805c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f412805c",
  null
  
)

export default component.exports